import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const LandingPage = lazy(() => import('./pages/LandingPage'));
const DiscoverPage = lazy(() => import('./pages/DiscoverPage'));
const AuthPage = lazy(() => import('./pages/AuthPage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));

export default function App() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-[#111111] flex items-center justify-center text-[#e5e5e5] font-mono">Loading...</div>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/login" element={<AuthPage />} />
        <Route path="/signup" element={<AuthPage />} />
        <Route path="/forgot-password" element={<AuthPage />} />
        <Route path="/dashboard/*" element={<DashboardPage />} />
        <Route path="*" element={
          <div className="min-h-screen bg-[#111111] flex flex-col items-center justify-center text-[#e5e5e5] font-mono">
            <h1 className="text-4xl mb-4">404</h1>
            <p className="text-[#888888]">Page not found.</p>
            <a href="/" className="mt-8 text-white border-b border-[#333333] hover:border-white transition-colors pb-1">Return home</a>
          </div>
        } />
      </Routes>
    </Suspense>
  );
}
